"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnitSingularPluralLabel = void 0;
const baseTypes_1 = require("../../../core/baseTypes");
require("../types");
const getUnitSingularPluralLabel = (texts, count, retentionType) => {
    if (!retentionType) {
        return '';
    }
    const isSingular = count === 1;
    const keepUnit = {
        [baseTypes_1.RETENTION_TYPE.days]: isSingular ? texts.unitsLabelDaysSingular : texts.unitsLabelDaysPlural,
        [baseTypes_1.RETENTION_TYPE.months]: isSingular
            ? texts.unitsLabelMonthsSingular
            : texts.unitsLabelMonthsPlural,
        [baseTypes_1.RETENTION_TYPE.years]: isSingular
            ? texts.unitsLabelYearsSingular
            : texts.unitsLabelYearsPlural,
    };
    return keepUnit[retentionType] || '';
};
exports.getUnitSingularPluralLabel = getUnitSingularPluralLabel;
//# sourceMappingURL=getUnitSingularPluralLabel.js.map